import { X } from 'lucide-react';

/**
 * Small X button to void a pending/confirmed result. Visible in god mode only.
 * Shared by PairingRow and PairingCard.
 */
export function VoidResultButton({
  tableNumber,
  onClick,
  className = '',
}: {
  tableNumber: number;
  onClick: () => void;
  className?: string;
}) {
  return (
    <button
      className={`h-5 w-5 rounded border border-destructive/50 text-destructive hover:bg-destructive/10 ${className}`}
      data-testid={`void-result-${tableNumber}`}
      onClick={onClick}
    >
      <X className="mx-auto h-3 w-3" />
    </button>
  );
}
